/** Strategem 320 (Shield unit): fade-in target art instead of flying orb */
export const SHIELD_UNIT_TARGET_IMAGE_PATH = '/images/shield_unit_target.png';
export const SHIELD_UNIT_TARGET_FADE_DURATION_MS = 720;
